import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid,TablePagination, Paper } from '@material-ui/core';
import theme from '../../../app/config/themaConfig';




const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    card: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(2),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        height: '80px',
        marginTop: '-1%',
        marginBottom: '2%'
    }
}));

export default function ListHistorialAlc({ onPageChange, rowsPerPage, onRowsPerPageChange, fechaIni, fechaFin, rows, isLoadUser, page, size, totalElement, setPage }) {

    const classes = useStyles();
    const r = rows !== undefined && rows !== null ? rows.sort((a, b) => a.ies < b.ies ? 1 : -1) : []

    useEffect(async () => {

    }, [page, size]);
    const primaryColor = theme.palette.primary.main;


    return (
        <>

            {isLoadUser ? <>cargando...</> : r.map((row) => (
                <Paper className={classes.card}>
                    <Grid container spacing={1}>
                        <Grid item style={{ width: '15%', paddingLeft: '1%', fontWeight: 'bold', fontSize: '16px' }}>
                            {row.cedula == null ? "-" : row.cedula}
                        </Grid>
                        <Grid item style={{ width: '25%', paddingLeft: '12%', fontWeight: 'bold', fontSize: '16px' }}>
                            {row.celular}
                        </Grid>
                        <Grid  style={{ width: '25%', paddingLeft: '10%', fontWeight: 'bold', fontSize: '16px' }}>
                            {Number(row.alcoholimetria).toFixed(2).toString().substring(0, row.alcoholimetria.toString().length - 2)}
                        </Grid>
                        <Grid style={{ width: '30%', paddingLeft: '6%', fontWeight: 'bold', fontSize: '16px' }} >
                            {row.datecreated ? new Date(row.datecreated).toLocaleDateString('es-ES', { day: 'numeric', month: 'numeric', year: 'numeric' }) + ' ' + new Date(row.datecreated).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }) : '--'}

                        </Grid>

                    </Grid>
                </Paper>
            ))}



            <Grid >
                <TablePagination
                    component="div"
                    count={totalElement}
                    page={page}
                    onPageChange={onPageChange}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={onRowsPerPageChange}
                    labelRowsPerPage="Datos por página:"
                    style={{ color: primaryColor }}
                    rowsPerPageOptions={[10, 25, 50, 100, 150, 200]}
                />
            </Grid>


        </>
    );


}